import { Box, Button, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import JM from 'jalali-moment';
import { forwardRef } from 'react';
import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

const DuelTableRow = forwardRef((props, ref) => {
  const {
    row,
    rowNumber,
    selected,
    onSelectRow,
    onEditRow,
    onDeleteRow,
    openLeaderboardModal,
    isDragging,
    isDraggable,
    setSelectedRow,
    onAddGift,
    ...rest
  } = props;

  const {
    DuelTitle,
    GameName,
    DuelOrderBy,
    GameLogo,
    DuelJoinNeedPayment,
    DuelAmount,
    TransactionAmountTypeLable,
    DuelCreateTime,
    DuelExpireTime,
    DuelIsActive,
  } = row;

  return (
    <TableRow
      hover
      selected={selected}
      ref={ref}
      style={{
        width: '100%',
        background: isDragging ? '#f4f6f8' : '',
        ...rest.style,
      }}
      {...rest}
    >
      <TableCell padding="checkbox">
        <div className="min-w-10">
          {isDraggable ? (
            <div className="flex justify-center items-center">
              <Iconify icon={'mdi:drag'} sx={{ width: '30px', height: '30px' }} />
            </div>
          ) : (
            <Checkbox checked={selected} onClick={onSelectRow} />
          )}
        </div>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{rowNumber}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{DuelTitle}</Typography>
      </TableCell>

      <TableCell className={!isDragging ? 'fixed-table-cell' : ''}>
        <div className="flex items-center gap-1">
          <MyAvatar alt={GameName} sx={{ mr: 1 }} src={GameLogo} />
          <Typography variant="body2" noWrap>
            {GameName}
          </Typography>
        </div>
      </TableCell>

      <TableCell>{JM(DuelCreateTime).locale('fa').format('YYYY/MM/DD')}</TableCell>

      <TableCell>{JM(DuelExpireTime).locale('fa').format('YYYY/MM/DD')}</TableCell>

      <TableCell align="center">
        <Typography variant="body2">{DuelOrderBy + 1}</Typography>
      </TableCell>

      {/* <TableCell align="center">
        <Typography variant="body2">{Number(DuelMinimumScore)}</Typography>
      </TableCell> */}

      <TableCell align="center">
        <Typography variant="body2">{DuelJoinNeedPayment ? TransactionAmountTypeLable : '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{DuelJoinNeedPayment ? DuelAmount?.toLocaleString() : '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Label variant="ghost" color={(DuelJoinNeedPayment === 0 && 'error') || 'success'} sx={{ textTransform: 'capitalize' }}>
          {(DuelJoinNeedPayment === 0 && 'خیر') || 'بله'}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Label
          variant="ghost"
          sx={{ textTransform: 'capitalize' }}
          color={DuelIsActive === 1 ? 'success' : DuelIsActive === 2 ? 'error' : 'warning'}
        >
          {DuelIsActive === 1 ? 'فعال' : DuelIsActive === 2 ? 'غیرفعال' : 'حذف شده'}
        </Label>
      </TableCell>

      <TableCell align="right">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          <Button
            size="small"
            color="secondary"
            variant="contained"
            onClick={() => {
              setSelectedRow(row);
              onAddGift();
            }}
          >
            ایجاد جایزه
          </Button>
          <Button
            size="small"
            color="warning"
            variant="contained"
            onClick={() => {
              openLeaderboardModal();
              setSelectedRow(row);
            }}
            sx={{ width: '110px' }}
          >
            مشاهده رتبه بندی
          </Button>

          <Button size="small" color="info" variant="contained" onClick={onEditRow}>
            ویرایش
          </Button>

          <Button size="small" color="error" variant="contained" onClick={onDeleteRow}>
            حذف
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
});

export default DuelTableRow;
